<template>
  <div class="qualityIndicatorsReport">
    <!-- 导航栏 -->
    <nav-header :head-title="headeName"></nav-header>
    <div class="container">
      <!-- 已完成盒子 -->
      <div
        class="user-info"
        v-if="this.reportData.reportState === '1' || this.reportData.reportState === '2'"
      >
        <div class="row-status df-between">
          <div class="status">表单已提交上报</div>
          <div class="edit-btn df-center" @click="goEdit">
            {{ reportStatus == 0 ? "我要修改" : "已提交" }}
          </div>
        </div>
        <div class="row-update-info">
          最后修改人及时间：<span>{{ reportData.modUserName }}</span
          >{{ reportData.modTime }}
        </div>
      </div>
      <template v-if="this.reportDataList && this.reportDataList.length > 0">
        <!-- 卡片容器 -->
        <div class="card-container">
          <div class="card" :id="'domItem' + index" :style="{'margin-top': item.bottomLine == '1' && index != 0 ? '10px' : '0px' }" v-for="(item, index) in reportDataList" :key="index" >
            <!-- ifShow为固定显示的项，showExpression为计算显示的项 -->
            <!-- 标题 -->
            <div class="title-box" v-if="item.ifShow == '1' && item.entryType != 13" >
              <div class="main-title" :style="{'margin-bottom': item.explains ? '0px' : item.children && item.children.length > 0 ? '15px' : '25px'}">
                <span class="name">
                  {{ item.prefixCode }}
                  <span v-html="item.entryName"></span>
                  <span class="asterisk" v-if="item.isRequired == 1 && (item.entryType == 5 || item.entryType == 6)">*</span>
                </span>
              </div>
              <div class="sub-title" v-if="item.explains"> {{ item.explains }} </div>
            </div>
            <!-- 标题下的每一项 -->
            <div>
              <template v-if="item.ifShow == '1'">
                <!-- 输入框 -->
                <div class="cell-item cell-item-15 df-item-center" v-if="item.entryType == 13">
                  <div class="df-item-center" style="width: 60%;">
                    <span class="asterisk" v-if="item.isRequired == 1">*</span>
                    <div class="title">{{ item.entryName }}</div>
                  </div>
                  <div :style="{'width': item.unit ? `calc(40% - ${item.unitWidth})` : '40%'}">
                    <van-field
                      v-model="item.entryValue"
                      :type="item.entryType == 13 ? 'number' : 'text'"
                      class="va-input df-item-center"
                      placeholder="请填写"
                      input-align="center"
                      @blur="handleBlur(item, index)"
                      @input="handleInput(item, index)"
                      :disabled="forbid"
                      :maxLength="item.maxLength ? item.maxLength : item.entryType == 2 ? '100' : '8'"
                    />
                  </div>
                  <div class="unit" :class="'unit' + index" v-if="item.unit" :style="{ width: item.unitWidth }">{{ item.unit }}</div>
                </div>
                <!-- 单选 -->
                <div class="cell-item cell-item-20" v-if="item.entryType == 5">
                  <van-radio-group
                    v-model="item.entryValue"
                    direction="horizontal"
                    icon-size="18px"
                    :disabled="forbid"
                    @change="toggleRadioChange(item, index)"
                  >
                    <van-radio :name="d.optionValue" v-for="(d,idx) in item.optionList" :key="idx">{{d.optionName}}</van-radio>
                  </van-radio-group>
                </div>
                <!-- 多选框 -->
                <div class="cell-item cell-item-20" v-if="item.entryType == 6">
                  <div class="checkbox-wrapper">
                    <van-checkbox-group 
                      v-model="item.entryValue" 
                      :disabled="forbid"
                      @change="val => handleCheckboxChange(val, item, index)"
                    >
                      <van-checkbox
                        shape="square"
                        :name="d.optionValue" 
                        v-for="(d, idx) in item.optionList" 
                        :key="idx"
                        class="checkbox-item"
                        :style="{'margin-bottom': idx == item.optionList.length - 1 ? '0px' : '20px'}"
                      >
                        {{ d.optionName }}
                      </van-checkbox>
                    </van-checkbox-group>
                  </div>
                </div>
              </template>
              <!-- `ENTRY_TYPE` varchar(5) DEFAULT NULL COMMENT '条目类型:1普通条目不需要计算值,2为文本类型,3为整数类型4,为小数类型,5为单选6为多选,7为下拉框(复选),8为单选框类型,9为下拉框单选,10为单元,11为医院,12需要根据OPTION计算值13.百分比14千分比，15为文本域',16二级联动时的父级(单选)17,二级联动时的子级(输入及单选) -->
              <!-- 可以添加多组的情况 -->
              <div class="group-box" v-if="item.ifShow == '1' && item.children && item.children.length > 0">
                <div class="group-content" v-for="(groupItem, groupIdx) in item.children" :key="groupIdx">
                  <div class="group-tag df-center">不合格消耗品{{groupIdx + 1}}</div>
                  <img class="group-del" v-if="item.children.length > 1 && !forbid" @click="handleShowDelDalog(index, groupIdx)" src="../../assets/images/qualityIndicatorsReport/group-del.png" alt="">
                  <div class="group-item" :id="'domItem' + index + groupIdx + cIdx" v-for="(cItem, cIdx) in groupItem" :key="cIdx" :style="{'padding-bottom': cIdx == groupItem.length - 1 ? '10px' : '0px'}" v-if="cItem.ifShow == '1'">
                    <!-- 输入框及选择框 -->
                    <div
                      class="cell-item cell-item-15"
                      :class="{'df-item-center': cItem.entryType != 7}"
                      v-if="cItem.entryType == 2 || cItem.entryType == 3 || cItem.entryType == 4 || cItem.entryType == 7 || cItem.entryType == 9 || cItem.entryType == 16 || cItem.entryType == 17"
                    >
                      <div class="df-item-center" :style="{'width':cItem.entryType == 7 ? '100%' : '33.33%' }">
                        <span class="asterisk" v-if="cItem.isRequired == 1">*</span>
                        <div class="title" :style="{'margin-bottom': cItem.entryType == 7 ? '15px' : '0px'}">{{ cItem.entryName }}</div>
                      </div>
                      <div @click="handleChildrenClick(index,groupIdx,cItem,cIdx)" class="item-right" :style="{'width': cItem.entryType == 7 ? '100%' : cItem.unit ? `calc(66.66% - ${cItem.unitWidth})` : '66.66%'}">
                        <!-- 2、3、4、17输入型 17能输入也能单选-->
                        <van-field
                          v-if="cItem.entryType == 2 || cItem.entryType == 3 || cItem.entryType == 4 || cItem.entryType == 17"
                          v-model="cItem.entryValue"
                          :type="cItem.entryType == 3 ? 'digit' : cItem.entryType == 4 ? 'number' : 'text'"
                          class="va-input df-item-center"
                          :placeholder="cItem.placeholder || '请填写'"
                          input-align="left"
                          @blur="handleChildrenBlur(index,groupIdx,cItem,cIdx)"
                          @input="handleChildrenInput(index,groupIdx,cItem,cIdx)"
                          :disabled="forbid"
                          :maxLength="cItem.maxLength ? cItem.maxLength : cItem.entryType == 2 || cItem.entryType == 17 ? '100' : '8'"
                        />
                        <div v-else-if="cItem.entryType == 7" class="checkbox-wrapper">
                          <van-checkbox-group
                            v-model="cItem.entryValue"
                            :disabled="forbid"
                            @change="() => {
                              if (reportData.context && cItem.entryCode) {
                                reportData.context[cItem.entryCode] = cItem.entryValue.join(',');
                              }
                              updateIfShow();
                            }"
                          >
                            <van-checkbox
                              shape="square"
                              :name="opt.optionValue"
                              v-for="(opt, idx) in cItem.optionList"
                              :key="idx"
                              v-if="opt.ifShow !== '0'"
                              class="checkbox-item"
                              :style="{'margin-bottom': idx === cItem.optionList.length - 1 ? '5px' : '20px'}"
                            >
                              {{ opt.optionName }}
                            </van-checkbox>
                          </van-checkbox-group>
                        </div>
                        <!-- 9、16选择型 -->
                        <van-field
                          v-else
                          :value="getDisplayValue(cItem)"
                          type="text"
                          class="va-input df-item-center"
                          placeholder="请选择"
                          input-align="left"
                          :readonly="true"
                          :disabled="forbid"
                        />
                        <div class="arrow" :class="{'multi-arrow':cItem.entryType == 7}" v-if="cItem.entryType == 9 || cItem.entryType == 16">
                          <img :style="{'transform': cItem.isShowSelect ? 'rotate(180deg)' : 'rotate(0deg)'}" :src="forbid ? arrowGray : arrowBlack"></img>
                        </div>
                        <div class="select-box" v-if="cItem.isShowSelect">
                          <div
                            v-if="k.ifShow == '1'"
                            @click.stop="handleConfirmSelect(index,groupIdx,cItem,cIdx,k.optionValue)" 
                            class="select-item df-item-center"
                            :class="{'select-item-active': isSelected(cItem, k.optionValue)}"
                            :style="{'border-radius':i==0?'10rpx 10rpx 0rpx 0rpx':i==cItem.optionList.length-1?'0rpx 0rpx 10rpx 10rpx':'none'}"
                            v-for="(k,i) in cItem.optionList" 
                            :key="i">
                            <span>{{k.optionName}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="unit" :class="'unit' + index + groupIdx + cIdx" v-if="cItem.unit" :style="{ width: cItem.unitWidth }">{{ cItem.unit }}</div>
                    </div>
                    <!-- textarea输入框 -->
                    <div class="cell-item" v-if="cItem.entryType == 15" >
                      <div class="title" style="margin-bottom:15px;">{{ cItem.entryName }}</div>
                      <div style="border:1px solid #eee;width: 100%;">
                        <van-field
                          v-model="cItem.entryValue"
                          rows="2"
                          autosize
                          label=""
                          type="textarea"
                          :maxlength="cItem.maxLength || 250"
                          :placeholder="cItem.placeholder || '请填写'"
                          show-word-limit
                          :disabled="forbid"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="add-group df-center" v-if="!forbid && item.children && item.children.length > 0" @click="handleAddGroup(index)">
                  <img src="../../assets/images/qualityIndicatorsReport/group-add.png" alt="">
                  <span class="btn">继续添加不合格消耗品</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 占位盒子 -->
        <div class="holder-box"></div>
        <!-- 操作按钮 -->
        <div
          class="btn-group df-between"
          v-if="this.reportData.reportState === '0' && reportStatus == 0"
        >
          <div class="storage df-center" @click="saveIndexOptionList('0')">
            暂存
          </div>
          <div class="submit df-center" @click="saveIndexOptionList('1')">
            提交
          </div>
        </div>
        <div
          class="btn-group"
          v-if="this.reportData.reportState === '1' && reportStatus == 0 && !forbid"
        >
          <div class="submit df-center" @click="saveIndexOptionList('1')">
            提交
          </div>
        </div>
      </template>

      <template v-else>
        <div></div>
      </template>
    </div>
    <v-dalog v-on:handleBtnLeft='handleBtnLeft' v-on:handleBtnRight='handleBtnRight' :isCenter='true' :isShowDalog='isShowDalog' :dalogContent='dalogContent' :isShowTwoButton="true"></v-dalog>
  </div>
</template>

<script>
import navHeader from "../../components/header/header.vue";
import vDalog from '../../components/dalog/v-dalog.vue'
import { mapState } from "vuex";
const replaceGroupIdx = (str, idx) => str ? str.replace(/GROUP\d+_/g, `GROUP${idx}_`) : '';
export default {
  components: {
    navHeader,
    vDalog
  },
  data() {
    return {
      currentIndex: 0,
      currentGroupIdx: 0,
      dalogContent:'',
      isShowDalog:false,
      arrowGray: require('../../assets/images/qualityIndicatorsReport/group-item-arrow-gray.png'),
      arrowBlack: require('../../assets/images/qualityIndicatorsReport/group-item-arrow.png'),
      defaultGroupItem: [], // 默认组
      currentGroupItem: {}, // 当前组
      currentcItem: {}, // 当前每一组下的子项
      currentTaskId:'',
      reportStatus: 0, // 0 未上报 1 已上报
      reportData: {},
      reportDataList: [],
      headeName: "",
      forbid: false, // 输入的禁用
    };
  },
  created() {
    this.currentTaskId = localStorage.getItem('taskId')
    this.reportStatus = this.$route.query.reportStatus;
    document.title = this.$route.query.titleName;
    this.headeName = document.title;
  },
  mounted() {
    this.getIndexResultDetailInfo();
  },
  watch: {
  },
  computed: {
    ...mapState({
      _userInfo: (state) => state.InvestorInfo,
    }),
  },
  methods: {
    handleCheckboxChange(newVal, item, index) {
      // 不做二次弹窗直接使用下方注释的代码
      // this.applyCheckbox(newVal, item, index);
      // return
      // 以下是做多选框取消二次弹窗逻辑
      const prev = item.lastMultiSelection || [];
      const removed = prev.filter(v => !newVal.includes(v));
      let foundMatchingGroup = false
      const removedStr = removed.join(',')
      this.reportDataList.forEach((v, i) => {
        if (v.children && v.children.length > 0) {
          v.children.forEach((v1, i1) => {
            v1.forEach((v2, i2) => {
              if (i2 == 0 && removedStr == v2.entryValue) {
                foundMatchingGroup = true
              }
            })
          })
        }
      })
      // 没有取消，只是新增或者没有匹配到的组时，直接落盘
      if (removed.length === 0 || !foundMatchingGroup) {
        this.applyCheckbox(newVal, item, index);
        item.lastMultiSelection = [...newVal];
        return;
      }
      console.log(removed,'当前取消选择的项')
      const removedNames = item.optionList
        .filter(opt => removed.includes(opt.optionValue))
        .map(opt => opt.optionName);
      // 先弹窗确认是否取消
      this.$dialog.confirm({
        title: '温馨提示',
        message: `取消后，将清空选择了${removedNames}的整组数据，是否确认取消？`,
      }).then(() => {
        this.applyCheckbox(newVal, item, index);
        item.lastMultiSelection = [...newVal];
        console.log(newVal,'确认取消后的多选数据')
        // 遍历数据，清空当前取消选择对应的entryValue(默认通过整组第0项的数据去匹配)的整组数据
        this.reportDataList.forEach((v,i)=>{
          if(v.children && v.children.length > 0){
            v.children.forEach((v1,i1)=>{
              v1.forEach((v2,i2)=>{
                if(i2 == 0 && removedStr == v2.entryValue){
                  // 找到当前i1对应的那组，然后遍历清空整组数据
                  v1.forEach((v3,i3)=>{
                    v3.isShowSelect = false
                    if(v3.entryType == 17){
                      v3.optionList = []
                    }
                    if(v3.entryType == 6 || v3.entryType == 7){
                      v3.entryValue = [];
                    } else {
                      v3.entryValue = null;
                    }
                    if(this.reportData.context && v3.entryCode){
                      this.reportData.context[v3.entryCode] = null;
                    }
                  })
                }
              })
            })
          }
        })
      }).catch(() => {
        // 取消：还原选中
        this.$nextTick(() => {
          item.entryValue = [...prev];
        });
      });
    },

    // 抽出原先写toggleCheckboxChange context/更新显示的逻辑
    applyCheckbox(val, item, index) {
      if (this.reportData.context && item.entryCode) {
        this.reportData.context[item.entryCode] =
          Array.isArray(val) ? val.join(',') : val;
      }
      this.updateIfShow();
      console.log(this.reportData.context, 'context数据');
    },
    // 去修改
    goEdit() {
      if (this.reportStatus == 1) {
        return;
      }
      if (this.$route.query.stepIsEnd == '1') {
        this.$toast('活动已结束，不能进行修改')
        return;
      }
      this.forbid = false;
    },
    saveIndexOptionList(temp){
      let entryList = JSON.parse(JSON.stringify(this.reportDataList))
      let flag = false
      let domId = ''
      entryList.forEach((v,i)=>{
        if(v.entryType == 6 || v.entryType == 7){ // 6多选和(7子项多选)
          v.entryValue = Array.isArray(v.entryValue) ? v.entryValue.join(',') : v.entryValue
        }
        if(v.ifShow == '1' && v.isRequired == 1 && (!v.entryValue || v.entryValue.length == 0)){
          flag = true
          domId = 'domItem' + i
        }
        if(v.children && v.children.length > 0){
          v.children.forEach((v1,i1)=>{
            v1.forEach((v2,i2)=>{
              if(v.ifShow == '1' && v2.isRequired == 1 && (!v2.entryValue || v2.entryValue.length == 0)){
                flag = true
                domId = 'domItem' + i + i1 + i2
              }
              if(v2.entryType == 6  || v2.entryType == 7){
                v2.entryValue = Array.isArray(v2.entryValue) ? v2.entryValue.join(',') : v2.entryValue
              }
            })
          })
        }
      })
      if(flag && temp == '1'){
        this.$toast('请完善必填项')
        let targetDom =  document.getElementById(domId)
        console.log(targetDom,'targetDom')
        setTimeout(() => {
          targetDom.scrollIntoView({behavior: "smooth", block: "center", inline: "center"})
        }, 200);
        return
      }
      // 校验完必填项后 增加ifShow == '0'时数据清空处理
      entryList.forEach((v, i) => {
        if (v.ifShow == '0') {
          v.entryValue = null;
          // 清空 context 中对应的值
          if (this.reportData.context && v.entryCode) {
            this.reportData.context[v.entryCode] = null;
          }
        }
        
        // 处理子项数据
        if (v.children && v.children.length > 0) {
          v.children.forEach((v1, i1) => {
            v1.forEach((v2, i2) => {
              if (v.ifShow == '0') {
                v2.entryValue = null;
                // 清空 context 中对应的值
                if (this.reportData.context && v2.entryCode) {
                  this.reportData.context[v2.entryCode] = null;
                }
              }
            });
          });
        }
      });
      let params = {
        comId: this._userInfo.data.comId,
        userId: this._userInfo.data.userId,
        data: {
          id: this.reportData.id,
          context: this.reportData.context,
          entryList: entryList,
          reportStatus: temp
        },
      };
      console.log(entryList,'提交时的entryList数据')
      console.log(this.reportData.context,'提交时的context数据')
      // return
      this.$http.submit(params).then((res) => {
        if (res.code === 0) {
          this.$router.go(-1)
        } else {
          this.$toast(res.msg);
        }
      });
    },
    handleShowDelDalog(index, groupIdx){
      this.currentIndex = index
      this.currentGroupIdx = groupIdx
      this.isShowDalog = true
      this.dalogContent = `确定删除不合格消耗品${groupIdx + 1}吗？`
    },
    handleBtnLeft(){
      this.isShowDalog = false
    },
    handleBtnRight(){
      this.isShowDalog = false
      this.handleGroupDel(this.currentIndex, this.currentGroupIdx)
    },
    // 删除时重排
    handleGroupDel(index, groupIdx) {
      this.reportDataList[index].children.splice(groupIdx, 1);
      this.reportDataList[index].children.forEach((v, i) => {
        v.forEach(v1 => {
          v1.entryCode = replaceGroupIdx(v1.entryCode, i);
          v1.parentCode = replaceGroupIdx(v1.parentCode, i);
          v1.childCode = replaceGroupIdx(v1.childCode, i);
          v1.showExpression = replaceGroupIdx(v1.showExpression, i);
          v1.dynamicOptionParamExpress = replaceGroupIdx(v1.dynamicOptionParamExpress, i);
        });
      });
    },

    // 新增时使用当前长度作为新组号
    handleAddGroup(index) {
      const nextIdx = this.reportDataList[index].children.length;
      const defaultGroupItem = this.defaultGroupItem.map(v => ({
        ...v,
        entryCode: replaceGroupIdx(v.entryCode, nextIdx),
        parentCode: replaceGroupIdx(v.parentCode, nextIdx),
        childCode: replaceGroupIdx(v.childCode, nextIdx),
        showExpression: replaceGroupIdx(v.showExpression, nextIdx),
        dynamicOptionParamExpress: replaceGroupIdx(v.dynamicOptionParamExpress, nextIdx),
      }));
      this.reportDataList[index].children.push(defaultGroupItem);
      this.updateIfShow();
      console.log(this.reportDataList[index].children,'组的数据')
    },
    // 计算显示状态
    updateIfShow() {
      // 辅助函数：根据 entryCode 查找对应的 entryValue
      const findEntryValue = (entryCode) => {
        if (!entryCode) return null;
        
        // 在主列表中查找
        for (let item of this.reportDataList) {
          if (item.entryCode === entryCode) {
            return item.entryValue;
          }
          
          // 在 children 中查找（children 是二维数组）
          if (item.children && Array.isArray(item.children)) {
            for (let group of item.children) {
              if (Array.isArray(group)) {
                for (let childItem of group) {
                  if (childItem.entryCode === entryCode) {
                    return childItem.entryValue;
                  }
                }
              }
            }
          }
        }
        
        // 如果找不到，尝试从 context 中获取
        return this.reportData.context && this.reportData.context[entryCode] !== undefined
          ? this.reportData.context[entryCode]
          : null;
      };
      
      const evalExp = (exp) => {
        if (!exp) return false;
        
        // 先处理包含方法调用的变量（如 ${GROUP0_ENTRY12}.indexOf）
        // 匹配模式：${VAR}.methodName 或 ${VAR}.property
        let replaced = exp.replace(/\$\{([^}]+)\}\.(\w+)/g, (match, varName, methodOrProp) => {
          const entryValue = findEntryValue(varName);
          let value = entryValue;
          
          // 如果值为 null 或 undefined，返回空字符串
          if (value === null || value === undefined) {
            value = '';
          }
          
          // 如果是数组，转换为逗号分隔的字符串（用于 indexOf 判断）
          if (Array.isArray(value)) {
            value = value.join(',');
          }
          
          // 转换为字符串类型，以便调用字符串方法
          value = String(value);
          
          // 返回可以调用方法的表达式
          return `'${value}'.${methodOrProp}`;
        });
        
        // 再处理普通的变量引用（不包含方法调用）
        replaced = replaced.replace(/\$\{([^}]+)\}/g, (_, varName) => {
          const entryValue = findEntryValue(varName);
          let value = entryValue;
          
          // 如果值为 null 或 undefined，返回空字符串
          if (value === null || value === undefined) {
            value = '';
          }
          
          // 如果是数组，转换为逗号分隔的字符串
          if (Array.isArray(value)) {
            value = value.join(',');
          }
          
          // 转换为字符串类型
          value = String(value);
          
          // 返回带引号的字符串，用于比较和逻辑判断
          // 对于逻辑判断，空字符串会被视为 false
          return `'${value}'`;
        });
        
        try {
          return new Function(`return (${replaced});`)();
        } catch (e) {
          console.error('表达式计算错误:', exp, '替换后:', replaced, e);
          return false;
        }
      };
      
      // 在 evalExp 函数定义之后，forEach 循环之前添加辅助函数
      const processShowExpression = (item) => {
        // 处理 showExpression：表达式为 true 时显示
        if (item.showExpression) {
          item.ifShow = evalExp(item.showExpression) ? '1' : '0';
        }
        // 处理 notShowExpression：表达式为 true 时不显示（优先级更高）
        if (item.notShowExpression) {
          item.ifShow = evalExp(item.notShowExpression) ? '0' : '1';
        }
      };

      const processOptionList = (optionList) => {
        if (optionList && Array.isArray(optionList)) {
          optionList.forEach(option => {
            processShowExpression(option);
          });
        }
      };

      // 优化后的主循环
      this.reportDataList.forEach(it => {
        // 处理主项
        processShowExpression(it);
        processOptionList(it.optionList);
        
        // 处理子项
        if (it.children && it.children.length) {
          it.children.forEach(c => {
            processShowExpression(c);
            processOptionList(c.optionList);
            
            // 处理子项数组
            if (Array.isArray(c)) {
              c.forEach(cItem => {
                processShowExpression(cItem);
                processOptionList(cItem.optionList);
              });
            }
          });
        }
      });
      console.log("展示数据this.reportDataList", this.reportDataList)
    },
    // 判断选项是否被选中
    isSelected(cItem, optionValue) {
      if (!cItem.entryValue) return false;
      const selectedValues = Array.isArray(cItem.entryValue) 
        ? cItem.entryValue 
        : (cItem.entryValue ? cItem.entryValue.split(',') : []);
      return selectedValues.includes(String(optionValue));
    },
    // 处理选择型输入框的显示
    getDisplayValue(cItem) {
      const selected = cItem.entryValue ? String(cItem.entryValue) : '';
      if (!selected) return '';

      const firstOpt = (cItem.optionList || []).find(
        o => String(o.optionValue) === selected
      );
      return firstOpt ? firstOpt.optionName : selected;
    },
    handleInputLImit(item) {
      // 不允许输入负数
      if (item.entryValue && item.entryValue.toString().includes('-')) {
        item.entryValue = item.entryValue.toString().replace(/-/g, '');
        // this.$toast('不允许输入负数');
      }
      
      // 处理前置0的情况（01 -> 1, 001 -> 1）
      if (item.entryValue && /^0+[0-9]+$/.test(item.entryValue.toString())) {
        const numVal = Number(item.entryValue);
        if (!isNaN(numVal)) {
          item.entryValue = String(numVal);
        }
      }
      // 处理最大最小值限制
      if (item.maxValue !== null && item.maxValue !== '' && item.maxValue !== undefined) {
        const maxVal = Number(item.maxValue);
        const currentVal = Number(item.entryValue);
        if (!isNaN(maxVal) && !isNaN(currentVal) && currentVal > maxVal) {
          // this.$toast(`输入值不能超过 ${item.maxValue}`);
          item.entryValue = String(maxVal);
        }
      }
      
      if (item.minValue !== null && item.minValue !== '' && item.minValue !== undefined) {
        const minVal = Number(item.minValue);
        const currentVal = Number(item.entryValue);
        if (!isNaN(minVal) && !isNaN(currentVal) && currentVal < minVal) {
          // this.$toast(`输入值不能小于 ${item.minValue}`);
          item.entryValue = String(minVal);
        }
      }
    },
    formatDecimalPoint(item){
      if(item.entryType == 4 || item.entryType == 13 || item.entryType == 14){
        let strValue = item.entryValue.toString()
        // 处理"100."的情况，去除末尾的小数点
        if (strValue.endsWith('.')) {
          strValue = strValue.slice(0, -1);
        }
        item.entryValue = strValue
      }
    },
    handleChildrenBlur(index,groupIdx,cItem,cIdx){
      this.formatDecimalPoint(cItem)
    },
    handleBlur(item){
      this.formatDecimalPoint(item)
    },
    handleInput(item, index){
      this.handleInputLImit(item)
      if (this.reportData.context && item.entryCode) {
        this.reportData.context[item.entryCode] = item.entryValue;
      }
    },
    // expr 形如 "{\"parentCode\":\"${GROUP0_ENTRY8}\"}"
    parseDynamicOptionParams(expr, cItem) {
      if (!expr) return {};
      let obj;
      try {
        obj = JSON.parse(expr);
      } catch (e) {
        console.error('dynamicOptionParamExpress 解析失败', expr, e);
        return {};
      }

      // 先把当前项的最新值写回 context，避免用到上一次的 entryValue
      const ctx = this.reportData.context || {};
      if (cItem && cItem.entryCode) {
        ctx[cItem.entryCode] = Array.isArray(cItem.entryValue)
          ? cItem.entryValue.join(',')
          : cItem.entryValue;
      }

      const replaceVars = val =>
        typeof val === 'string'
          ? val.replace(/\$\{([^}]+)\}/g, (_, key) => ctx[key] ?? '')
          : val;

      return Object.fromEntries(
        Object.entries(obj).map(([k, v]) => [k, replaceVars(v)])
      );
    },
    handleDynamicOptionList(index,groupIdx,cItem,cIdx,optionValue){
      const dynamicData = this.parseDynamicOptionParams(cItem.dynamicOptionParamExpress, cItem);
      console.log(dynamicData,'解析后的动态参数')
      let params = {
        isloading: false,
        comId: this._userInfo.data.comId,
        userId: this._userInfo.data.userId,
        dynamicOptionExpress: cItem.dynamicOptionExpress,
        data: dynamicData
      };
      this.$http.getCommonOptions(params).then((res) => {
        if (res.code === 0) {
          // 暂只匹配当前组
          const group = this.reportDataList[index].children[groupIdx];
          const target = group.find(child => child.entryCode === cItem.childCode);
          if (target) {
            this.$set(target, 'optionList', res.data || []);
            // 目标子项有可见选项时才展开
            target.isShowSelect = (target.optionList || []).some(opt => opt.ifShow !== '0');
          }
        } else {
          this.$toast(res.msg);
        }
      });
    },
    // 处理下拉框是否显示
    filterOptionsAndToggle(cItem){
      // 输入联想：按 optionName / optionValue 模糊匹配当前组的 optionList
      if (cItem.entryType == 17 && Array.isArray(cItem.optionList)) {
        const keyword = (cItem.entryValue || '').toString().trim();
        const noKeyword = keyword === '';
        let hitCount = 0;

        cItem.optionList.forEach(opt => {
          const nameHit = String(opt.optionName || '').includes(keyword);
          const valueHit = String(opt.optionValue || '').includes(keyword);
          const hit = noKeyword || nameHit || valueHit;
          opt.ifShow = hit ? '1' : '0';
          if (hit) hitCount += 1;
        });

        // 只有有可见项时才展开
        cItem.isShowSelect = hitCount > 0;
      }
    },
    // 存在子项的input点击时
    handleChildrenClick(index,groupIdx,cItem,cIdx){
      console.log(index,groupIdx,cItem,cIdx,'点击时的 index,groupIdx,cItem,cIdx')
      if(this.forbid) {
        return
      }
      if(cItem.entryType == 7){
        return
      }
      this.currentcItem = cItem
      // 单选下拉框(16、17)的情况
      if (cItem.optionList && Array.isArray(cItem.optionList) && cItem.optionList.length > 0) {
        // 先关闭所有其他已打开的下拉框
        this.reportDataList.forEach(item => {
          // 关闭主项的下拉框
          if (item.isShowSelect) {
            item.isShowSelect = false;
          }
          // 关闭子项的下拉框
          if (item.children && item.children.length) {
            item.children.forEach(groupItem => {
              if (Array.isArray(groupItem)) {
                groupItem.forEach(childItem => {
                  if (childItem.isShowSelect && childItem !== cItem) {
                    childItem.isShowSelect = false;
                  }
                });
              } else if (groupItem.isShowSelect && groupItem !== cItem) {
                groupItem.isShowSelect = false;
              }
            });
          }
        });
        if(cItem.entryType == 17){
          this.filterOptionsAndToggle(cItem)
          return
        }
        cItem.isShowSelect = !cItem.isShowSelect
      }
    },
    // 存在子项的input变化时
    handleChildrenInput(index,groupIdx,cItem,cIdx){
      console.log(index,groupIdx,cItem,cIdx,'输入时的index,cItem,cIdx')
      cItem.isShowSelect = false
      this.filterOptionsAndToggle(cItem)
      this.handleInputLImit(cItem)
      // 更新 context
      if (this.reportData.context && cItem.entryCode) {
        this.reportData.context[cItem.entryCode] = cItem.entryValue;
      }
    },
    // 子项下拉框确定选择时
    handleConfirmSelect(index,groupIdx,cItem,cIdx,optionValue) {
      console.log(index,groupIdx,cItem,cIdx,optionValue,'子项下拉框确定选择时的 index,groupIdx,cItem,cIdx')
      const valStr = String(optionValue);
      if (cItem.entryType == 7) {
        // 多选
        if (!Array.isArray(cItem.entryValue)) {
          cItem.entryValue = cItem.entryValue
            ? (typeof cItem.entryValue === 'string' ? cItem.entryValue.split(',') : [cItem.entryValue])
            : [];
        }
        const hit = cItem.entryValue.indexOf(valStr);
        if (hit > -1) cItem.entryValue.splice(hit, 1);
        else cItem.entryValue.push(valStr);
        this.updateIfShow();
      } else if (cItem.entryType == 9 || cItem.entryType == 16 || cItem.entryType == 17) {
        // 单选
        cItem.entryValue = valStr;
        cItem.isShowSelect = false; // 如需选完收起下拉
        if(cItem.entryType == 16 && cItem.childCode){ // 清空childCode对应的entryCode的entryValue
          this.reportDataList[index].children[groupIdx].forEach(c => {
            if (c.entryCode == cItem.childCode) {
              c.entryValue = null;
            }
          });
          this.handleDynamicOptionList(index,groupIdx,cItem,cIdx,optionValue)
        }
      }

      // 更新 context
      if (this.reportData.context && cItem.entryCode) {
        this.reportData.context[cItem.entryCode] = Array.isArray(cItem.entryValue)
          ? (cItem.entryValue.length ? cItem.entryValue.join(',') : null)
          : cItem.entryValue;
      }

      console.log(cItem.entryValue, '选中的值');
    },
    toggleRadioChange(item, index){
      if (this.reportData.context && item.entryCode) {
        this.reportData.context[item.entryCode] = item.entryValue;
      }
      this.updateIfShow();
      console.log(this.reportData.context,'context数据')
      console.log(this.reportDataList,'reportDataList数据')
    },
    toggleCheckboxChange(item, index){
      if (this.reportData.context && item.entryCode) {
        // 将数组转换为字符串，用逗号分隔
        this.reportData.context[item.entryCode] = Array.isArray(item.entryValue) 
          ? item.entryValue.join(',') 
          : item.entryValue;
      }
      this.updateIfShow();
      console.log(this.reportData.context, 'context数据')
      console.log(this.reportDataList, 'reportDataList数据')
    },
    // 获取报告列表数据
    getIndexResultDetailInfo() {
      let params = {
        comId: this._userInfo.data.comId,
        userId: this._userInfo.data.userId,
        data: {
          id: this.$route.query.id,
        },
      };
      this.$http.getById(params).then((res) => {
        if (res.code === 0) {
          this.reportData = res.data ? res.data : [];
          this.reportDataList = res.data.entryList;
          this.forbid = this.reportData.reportState === "1" || this.reportData.reportState === "2";
          // 处理多选框数据，确保 entryValue 是数组
          if (this.reportDataList && this.reportDataList.length > 0) {
            this.reportDataList.forEach(item => {
              this.$set(item, 'unitWidth', this.calcUnitWidth(item.unit))
              if (item.entryType == 6 || item.entryType == 7) {
                // 先处理成干净的数组（防止出现的['3', ',', '4']脏数据）
                const cleanArray = item.entryValue ? item.entryValue.split(',').map(s => s.trim()).filter(Boolean) : [];
                // 用干净的数组初始化 lastMultiSelection(暂只有主项多选做了多选二次确认的处理)
                this.$set(item, 'lastMultiSelection', [...cleanArray]);
                item.entryValue = cleanArray;
              }
              if(item.children && item.children.length > 0){
                // 先赋值 defaultGroupItem，并重置其 entryValue
                this.defaultGroupItem = item.children[0].map(ci => ({
                  ...ci,
                  entryValue: (ci.entryType == 6 || ci.entryType == 7) ? [] : '',
                  isShowSelect: false,
                  unitWidth: this.calcUnitWidth(ci.unit),
                }));
                item.children.forEach((groupItem,groupIdx) => {
                  groupItem.forEach((cItem,cIndex) =>{
                    this.$set(cItem, 'isShowSelect', false)
                    this.$set(cItem, 'unitWidth', this.calcUnitWidth(cItem.unit))
                    if (cItem.entryType == 6 || cItem.entryType == 7) {
                      cItem.entryValue = cItem.entryValue ? cItem.entryValue.split(',') : [];
                    }
                  })
                })
              }
            });
            console.log(this.defaultGroupItem,'添加时默认的组数据')
          }
          this.updateIfShow();
        } else {
          this.$toast(res.msg);
        }
      });
    },
    // 工具：测量文字宽度，可缓存字体和结果
    measureTextWidth(text, font = '16px PingFangSC, sans-serif') {
      const canvas = this.__unitCanvas || (this.__unitCanvas = document.createElement('canvas'));
      const ctx = canvas.getContext('2d');
      ctx.font = font;
      return Math.ceil(ctx.measureText(text || '').width);
    },
    // 根据 unit 计算宽度（加一点 padding）
    calcUnitWidth(unitVal, pad = 10) {
      if (!unitVal) return '';
      return `${this.measureTextWidth(String(unitVal)) + pad}px`;
    },
  },
};
</script>

<style lang='scss' scoped>
/deep/ .van-field{
  font-size: 16px;
}
.checkbox-wrapper {
  .checkbox-item {
    font-size: 16px;
    color: #333;
    font-family: PingFangSC-Regular, PingFang SC;
  }
}
.group-box{
  padding: 0px 0px 20px;
  .group-content{
    margin-bottom: 10px;
    padding: 25px 12px 0px;
    position: relative;
    background: #f9fafb;
    .group-tag{
      position: absolute;
      top: 0;
      left: 0;
      padding: 0px 10px;
      height: 18px;
      font-size: 13px;
      font-family: PingFang SC, PingFang SC-Regular;
      color: #ffffff;
      background: #1c91ff;
      border-radius: 0px 10px 10px 0px;
    }
    .group-del{
      position: absolute;
      top: 0;
      right: 0;
      width: 16px;
      height: 16px;
    }
  }
  .add-group{
    height: 40px;
    border: 1px solid #cccccc;
    img{
      width: 22px;
      height: 22px;
      margin-right: 5px;
    }
    .btn{
      font-size: 17px;
      font-family: PingFang SC, PingFang SC-Medium;
      color: #1c91ff;
    }
  }
}


.qualityIndicatorsReport {
  background-color: #f2f2f2;
  height: 100vh;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  display: flex;
  flex-direction: column;
  .asterisk {
    color: red;
    font-size: 16px;
    margin-right: 3px;
    // margin-top: 3px;
  }
  .container {
    flex: 1;
    overflow: scroll;
  }
  .user-info {
    min-height: 82px;
    background: #e5efff;
    box-sizing: border-box;
    padding: 10px 15px 15px;
    margin-bottom: 10px;
    .status {
      font-size: 16px;
      color: #333333;
      line-height: 22px;
    }
    .edit-btn {
      width: 90px;
      height: 30px;
      opacity: 1;
      border: 1px solid #26b4ff;
      border-radius: 17px;
      font-size: 15px;
      color: #26b4ff;
    }
    .row-update-info {
      margin-top: 6px;
      font-size: 14px;
      color: #999999;
      line-height: 20px;
      span {
        margin-right: 8px;
      }
    }
  }
  .card-container {
    .card {
      box-sizing: border-box;
      padding: 0 14px 0 15px;
      background-color: #fff !important;
      .title-box {
        padding-top: 15px;
        .main-title {
          .name {
            font-size: 16px;
            font-weight: 500;
            color: #333333;
            line-height: 22px;
          }
          .rate {
            flex-shrink: 0;
            font-size: 14px;
            color: rgb(51, 153, 255);
          }
        }
        .sub-title {
          padding: 5px 0px 15px;
          font-size: 14px;
          font-weight: 400;
          text-align: left;
          color: #999999;
          line-height: 20px;
        }
      }
      .cell-item {
        min-height: 40px;
        .title {
          text-align: left;
          // width: 180px;
          flex: 1;
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          line-height: 22px;
        }
        .item-right{
          position: relative;
          width: 50%;
          .arrow {
            width: 22px;
            height: 22px;
            position: absolute;
            top: 50%;
            right: 5px;
            transform: translateY(-50%);
            img{
              width: 100%;
              height: 100%;
            }
          }
          .multi-arrow{
            top: 10px;
            transform: translateY(0%);
          }
          .va-input{
            width: 100%;
            margin: 0px;
            padding-left: 15px;
          }
          .select-box {
            max-height: 250px;
            overflow: scroll;
            width: 100%;
            position: absolute;
            top: 40px;
            background-color: #fff;
            z-index: 999;
            border: 1px solid #eeeeee;
            border-radius: 5px;
            box-shadow: 0px 2px 4px 0px rgba(200, 200, 200, 0.50);
      
            .select-item {
              height: 44px;
              padding-left: 12px;
              border-bottom: 1px solid #eee;
              font-size: 15px;
            }
      
            .select-item-active {
              background-color: #26b4ff;
              color: #fff;
            }
      
          }
        }
        input,
        .va-input {
          margin: 0 ;
          width: 100%;
          height: 38px;
          background: #ffffff;
          border: 1px solid #cccccc;
          font-size: 16px;
          padding: 0;
          // text-align: center;
          // line-height: 22px;
        }
        ::-webkit-input-placeholder {
          /* WebKit, Blink, Edge */
          color: #999999;
        }
        :-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #999999;
        }
        ::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #999999;
        }
        :-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          color: #999999;
        }
        .unit {
          text-align: right;
          // width: 50px;
          // flex-shrink: 0;
          // margin-left: auto;
          font-size: 16px;
          color: #333333;
        }
      }
      .cell-item-20{
        padding-bottom: 20px;
      }
      .cell-item-15{
        padding-bottom: 15px;
      }
    }
  }
  .btn-group {
    position: fixed;
    width: 100%;
    height: 44px;
    background: #ffffff;
    z-index: 99;
    bottom: 0;
    box-sizing: border-box;
    div {
      flex: 1;
      height: 100%;
    }
    .storage {
      background: #ffffff;
      font-size: 18px;
      color: #1c91ff;
    }
    .submit {
      background: #1c91ff;
      font-size: 18px;
      color: #ffffff;
    }
  }

  /deep/ .van-radio__label {
    margin-right: 60px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 16px;
    color: #333;
    line-height: 20px;
  }
  .holder-box {
    width: 100%;
    height: 60px;
  }
}
</style>